import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { DSuccess } from "./depositlist";
import { fbq } from "../../fbq";
import { availSuccess, closeBonusModal } from "./gift";
const initialState = {
  data: null,
  loading: false,
  error: null,
};

// Create the slice
const TransaPicture = createSlice({
  name: "purchese",
  initialState,
  reducers: {
    Starting(state) {
      state.loading = true;
      state.error = null;
    },
    Success(state, action) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    CloseSuccess(state, action) {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
    Failure: (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.payload;
    },
  },
});

export const { Starting, Failure, CloseSuccess } = TransaPicture.actions;

export const uploadTransactionImages = (file) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await axios.post("/private/singleimage", formData, config);

    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message || "Batch upload failed.";
    toast.error(errorMessage);
    return null;
  }
};

export const PaymentSend = (data, navigate) => async (dispatch) => {
  try {
    dispatch(Starting());
    // 1) User submits billing/payment info → AddPaymentInfo
    const amt = Number(data?.amount ?? data?.value ?? 0);
    const cur = data?.currency || "USD";
    fbq("track", "AddPaymentInfo", {
      content_category: "Wallet",
      value: amt,
      currency: cur,
      payment_method: data?.company || data?.company || "unknown",
    });
    const response = await axios.post("/private/paycus", data);
    if (response?.status === 201) {
      if (data.company === "card") {
        window.location.href = response.data.url;
        return;
      }
      const user = response?.data;
      dispatch(DSuccess(user));
      dispatch(CloseSuccess());

      const paidAmount = Number(
        user?.amount ?? user?.paidAmount ?? data?.amount ?? 0,
      );
      const currency = user?.currency || cur;
      const orderId =
        user?.transactionId || user?.order_id || user?.id || Date.now();
      fbq("track", "Purchase", {
        value: paidAmount,
        currency,
        content_name: "Wallet Top-Up",
        order_id: String(orderId),
      });
      dispatch(availSuccess());
    }
    return null;
  } catch (err) {
    toast.error(err?.response?.data?.message || err);
    dispatch(Failure(err?.response?.data?.message || err));
    dispatch(closeBonusModal());
    return null;
  }
};

export default TransaPicture.reducer;
